import CollapsingList from '../../general-ui/collapsing-list/collapsing-list';
import classNames from 'classnames';
import Icon, { COLORS, ICONS } from '../../general-ui/icon';
import { FILE_TYPES } from '../../../store/utils/content-utils';
import WaitingIndicator from '../../general-ui/waiting-indicator/waiting-indicator';
import { useDispatch, useSelector } from 'react-redux';
import { filterContent } from '../../../store/actions/admin/content-actions';
import ListHeaders from './list-headers';
import { EventsState } from '../../../store/types';
import Paging from '../../general-ui/paging/paging';
import './content-body.scss';

interface MenuItemsProps {
	fileType: number;
	title: string;
	value: number;
	iconName: string;
}
function MenuItem({ fileType, title, value, iconName }: MenuItemsProps) {
	const dispatch = useDispatch();
	return (
		<div
			className={classNames("content-menu-item", { selected: fileType === value })}
			onClick={(() => dispatch(filterContent(value)))}>
			<Icon name={iconName} size={16} color="" />
			<span>{title}</span>
		</div>
	);
}

const menu = {
	documents: [
		{
			title: "All",
			value: FILE_TYPES.ALL_DOCS
		},
		{
			title: "PDF",
			value: FILE_TYPES.PDF
		},
		{
			title: "Word",
			value: FILE_TYPES.WORD
		},
		{
			title: "Excel",
			value: FILE_TYPES.EXCEL
		},
		{
			title: "PowerPoint",
			value: FILE_TYPES.POWERPOINT
		},
		{
			title: "Misc",
			value: FILE_TYPES.MISC
		}
	],
	images: {
		title: "Images",
		value: FILE_TYPES.IMAGES
	},
	videos: [
		{
			title: "Recorded",
			value: FILE_TYPES.RECORDED,
		},
		{
			title: "Uploaded",
			value: FILE_TYPES.UPLOADED
		}
	],
	fonts: {
		title: "Fonts",
		value: FILE_TYPES.FONTS
	},
	palettes: {
		title: "Palettes",
		value: FILE_TYPES.PALETTES
	}
};

interface ContentBodyProps {
	displayList: JSX.Element[]
	idList: (number | string)[];
	pagingState: {
		page: number;
		setPage: (page: number) => void;
		totalPages: number;
	}
}

const ContentBody: React.FC<ContentBodyProps> = ({ displayList, idList, pagingState }) => {
	const {
		ContentReducer: {
			view,
			fileType,
			documentsLoading,
			ustreamVideosLoading,
		}
	} = useSelector((state: EventsState) => state);
	const dispatch = useDispatch();

	const getLoading = () => {
		switch (fileType) {
			case (FILE_TYPES.RECORDED): return ustreamVideosLoading;
			default: return documentsLoading;
		}
	};

	return (
		<div className="content-body">
			<div className="content-menu-container">
				<CollapsingList
					label="Documents"
					icon={<Icon name={ICONS.DOCUMENT} size={16} color={COLORS.GRAY} />}
				>
					<ul>
						{menu.documents.map(({ title, value }) => (
							<li key={title}
								className={classNames({ selected: fileType === value })}
								onClick={() => dispatch(filterContent(value))}
							>{title}</li>
						))}
					</ul>
				</CollapsingList>
				<MenuItem fileType={fileType} title={menu.images.title} value={menu.images.value} iconName={ICONS.IMAGE} />
				<CollapsingList
					label="Videos"
					icon={<Icon name={ICONS.CAMERA_OUTLINE} size={16} color={COLORS.GRAY} />}
				>
					<ul>
						{menu.videos.map(({ title, value }) => (
							<li key={title}
								className={classNames({ selected: fileType === value })}
								onClick={() => dispatch(filterContent(value))}
							>{title}</li>
						))}
					</ul>
				</CollapsingList>
				<MenuItem fileType={fileType} title={menu.fonts.title} value={menu.fonts.value} iconName={ICONS.FONTS} />
				<MenuItem fileType={fileType} title={menu.palettes.title} value={menu.palettes.value} iconName={ICONS.PALETTES} />
			</div>

			{getLoading()
				? <div className="waiting-indicator-container"><WaitingIndicator /></div>
				: (
					<ul
						className={classNames("content-list", view, { "colors-container": fileType === FILE_TYPES.PALETTES })}
					>
						{view === "list" && <ListHeaders idList={idList} />}
						{displayList}
						<li className="paging-li"><Paging {...pagingState} /></li>
					</ul>
				)
			}
		</div>
	);
};

export default ContentBody;


